/**
 *  接口配置
 *  let root = '';
 *  root += process.env.NODE_ENV === "production" ? "" : "/apis";
 * */
// let ibase = "/api/ibase";
// let iorder = "/api/iorder";
/**
 *  接口列表
 * */
const apis = {
  login:"/api/ibase/couponApi/login", //登录
  findRightsCount:"/api/ibase/couponApi/findRightsCount", // 获取权益次数
  findGoodsDetail:"/api/ibase/couponApi/findGoodsDetail", //查询商品详情
  findGoodsList:"/api/ibase/couponApi/findGoodsList" , //查询商品列表
  findOrderList:"/api/ibase/couponApi/findOrderList", // 查询订单列表
  findOrderDetail:"/api/ibase/couponApi/findOrderDetail", //查询订单详情
  getIdentifyingCode:"/api/ibase/member/getIdentifyingCode", //获取验证码
  couponCreateAndGetCode:"/api/ibase/couponApi/couponCreateAndGetCode", // 兑换奖券
  findGoodsRightsCount:"/api/ibase/couponApi/findGoodsRightsCount", // 查询兑换次数
  exitLogin:"/api/ibase/couponApi/exitLogin", // 退出
  getToken:'/api/ibase/OAuthApi/getToken',
  findCardorderDetailList:'/api/ibase/couponApi/findCardorderDetailList', 
  getCoupon: "/api/ibase/couponApi/getCoupon",
  findOrderListSingle:"/api/ibase/couponApi/findOrderListSingle"
  // login: ibase + "/login", //测试
  // order: iorder + "/login", //测试
  // applyOderBuyService: iorder + "/order/applyOderBuyService", //申请售后
  // buyWithPoints: iorder + "/order/buyWithPoints", //商品兑换接口
  // myOrderBuyList: iorder + "/order/myOrderBuyList", //趣豆订单列表
  // getOrderBuyDetail: iorder + "/order/getOrderBuyDetail", //趣豆订单详情
  // myOrderTransferList: iorder + "/order/myOrderTransferList", //转让订单列表
  // myOrderTransferDetail: iorder + "/order/myOrderTransferDetail", //转让订单详情
  // saveBaseInfo: iorder + "/order/inputCardNumAndDriverName", //输入车牌号和姓名

  // myAllScore: iorder + "/memberScore/myAllScore", //我所有趣豆
  // myMonthScoreCount: iorder + "/memberScore/myMonthScoreCount", //我的月趣豆获取和消费总数
  // myMonthScoreDetailList: iorder + "/memberScore/myMonthScoreDetailList", //我的月趣豆详情列表
  // transferScore: iorder + "/memberScore/transferScore", //转让趣豆

  // queryDataList: ibase + "/dict/queryDataList", //查询字典接口(商品分类)
  // queryGoodsList: iorder + "/goods/queryGoodsList", //查询商品列表接口
  // queryGoodsDetail: iorder + "/goods/queryGoodsDetail", //查询商品详情接口

  // queryTicketList: iorder + "/ticket/queryTicketList", //查询我的礼包列表接口
  // queryTicketDetail: iorder + "/ticket/queryTicketDetail", //查询我的礼包详情接口
  // transferApplication: iorder + "/transfer/transferApplication ", //转让申请
  // queryMemberCardList: iorder + "/ticket/queryMemberCardList ", //查询我的卡券列表

  // activate: ibase + "/member/activate", //激活
  // getIdentifyingCode: ibase + "/member/getIdentifyingCode", //获取验证码
  // getMemberInfo: ibase + "/member/getMemberInfo", //获取用户信息
  // register: ibase + "/member/register", //注册用户
  // activateTicketHis: ibase + "/member/activateTicketHis", //激活历史
  // getDetail: ibase + "/member/getDetail", //趣豆或卡券详情

  // rechargeWithPoints: iorder + "/order/rechargeWithPoints", //商品兑换接口
  // webUpload: iorder + "/upload/webupload", //上传附件

  // //第三方
  // insureTicketDetail: iorder + "/insureticket/insureTicketDetail", //保险卡包详情
  // toShowInsureCard: iorder + "/insureticket/toShowInsureCard", //查看保险卡
  // toUseInsureCard: iorder + "/insureticket/toUseInsureCard", //使用保险公司的卡

  // toShowCard: iorder +'/ticket/toShowCard',      //查看卡
  // toUseCard: iorder +'/ticket/toUseCard',      //使用卡
};

module.exports = {
  apis,
};
